import {
  BADGE_TYPE_ERROR,
  BADGE_TYPE_ORANGE,
  BADGE_TYPE_WARNING,
  BADGE_TYPE_GREEN,
  BADGE_TYPE_SUCCESS,
  BADGE_TYPE_DEFAULT
} from 'mailup-web-components'
import { pendoTrack } from './pendoTracking'

export const getDeliverabilityScoreColor = Score => {
  switch (true) {
    case Score < 30:
      return BADGE_TYPE_ERROR
    case Score < 50:
      return BADGE_TYPE_ORANGE
    case Score < 70:
      return BADGE_TYPE_WARNING
    case Score < 90:
      return BADGE_TYPE_GREEN
    case Score >= 90:
      return BADGE_TYPE_SUCCESS
    default:
      return BADGE_TYPE_DEFAULT
  }
}

export const mailupShieldBannerPendoTrack = (title, variant) => {
  pendoTrack(title, {
    DateTime: new Date().toISOString(),
    variant
  })
}
